import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import {
  LigneHorizontal,
  SubSectionTitle,
  SubSectionTitleContainer,
} from './Base';

const TitleText = styled.span`
  font-weight: bold;
  font-size: 15px;
`;

const RestaurantsHotel = ({ hotel }) => {
  const { t } = useTranslation('hotel');
  const restaurants = hotel?.restaurants.filter(elem => elem.displayName) || [];
  return (
    <>
      {restaurants.length > 0 && (
        <div className="my-6">
          <SubSectionTitleContainer>
            <SubSectionTitle>{t('restaurants')}</SubSectionTitle>
          </SubSectionTitleContainer>

          <div className="mt-4 grid grid-cols-2 gap-4">
            {restaurants.map((restaurant, index) => (
              <div className="bg-white rounded-lg shadow-k" key={index}>
                <div className="py-4 px-6">
                  <TitleText>{restaurant?.displayName}</TitleText>

                  {(restaurant?.restaurantFacilities || []).map((data, ind) => (
                    <div key={ind}>
                      <span>- {data.facility.displayName}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <LigneHorizontal />
        </div>
      )}
    </>
  );
};

export default RestaurantsHotel;
